// ==============================================
// FILE: frontend/src/hooks/useAuth.js
// ==============================================

import { useState, useEffect } from 'react';
import { apiService } from '../services/api.service';
import { STORAGE_KEYS } from '../config/api.config';

export function useAuth() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const userData = localStorage.getItem(STORAGE_KEYS.USER_DATA);
    if (userData) {
      try {
        setUser(JSON.parse(userData));
      } catch (error) {
        console.error('Failed to parse user data:', error);
      }
    }
    setLoading(false);
  }, []);

  const login = async (email, password) => {
    try {
      const response = await apiService.login(email, password);
      if (response.success && response.data?.user) {
        setUser(response.data.user);
        return response;
      }
      return response;
    } catch (error) {
      console.error('Login error:', error);
      return { success: false, error: 'Login failed' };
    }
  };

  const logout = () => {
    apiService.logout();
    setUser(null);
  };

  const isAuthenticated = apiService.isAuthenticated();
  const isAdmin = user?.role === 'admin' || user?.role === 'super_admin';
  const isSuperAdmin = user?.role === 'super_admin';

  return {
    user,
    loading,
    isAuthenticated,
    isAdmin,
    isSuperAdmin,
    login,
    logout,
  };
}